import React from 'react';


// SLICNO KAO READ-ONLY POLJE MEDJUTIM OVO KORISTIMO ZA LAZNA POLJA ZA WIDGETE KOJIMA SE POPUNJAVA PRAVA FORMA ILI PRIKAZ INFORMACIJA UNUTAR FORME KOJI NE PRIPADAJU FORMI.
const UniFieldDisplayFakeValue = (props) => {
  let params = {};
  if (props.params) {
    params = props.params;
  }
  let readonly = true; // uvek readonly
  let name = 'unnamed';
  if (typeof params.name === 'string' && params.name !== '') {
    name = params.name;
  }
  /*
  let formState = {};
  if (props.formState) {
    formState = props.formState;
  }
  let formErrors = {};
  if (props.formErrors) {
    formErrors = props.formErrors;
  }
  let handleChange = props.handleChange;
  if (typeof handleChange !== 'function') {
    handleChange = () => {};
  }
  */

  let fakeState = {};
  if (props.fakeState) {
    fakeState = props.fakeState;
  }

  let extraClass = '';
  if (typeof params.extraclass === 'string' && params.extraclass !== '') {
    extraClass = ' ' + params.extraclass;
  }

  let cl = 'uniformcompo__field uniformcompo__field--display-fake-value' + extraClass;
  /*
  if (typeof formErrors[name] === 'string' && formErrors[name] !== '') {
    cl += ' error';
  }
  */

  let style = {};
  if (params.w > 0) {
    style = {
      width: params.w
    };
  }

  let _value = '';
  if (fakeState[name]) {
    _value = fakeState[name]; // UPOZORENJE: ne mora da znaci da je ovo najbolje resenje, mozda je bolje da null bude prikazano kao "null"?! // TODO
  }

  let tooltip = null;
  if (typeof params.tooltip === 'string' && params.tooltip !== '') {
    tooltip = params.tooltip;
  }

  return (
    <div className={cl} style={style}>
      <label htmlFor={name}>
        {
          tooltip ? (<abbr title={tooltip}>{params.label}</abbr>) : (params.label)
        }
      </label>
      <input
        type="text"
        name={name}
        readOnly={readonly}
        value={_value}
      />
    </div>
  );
};

export default UniFieldDisplayFakeValue;